export default __webpack_public_path__ + "static/media/au_glpm.6422404e.jpg";